import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAssets, addAsset, updateAsset, deleteAsset } from '../../services/api/assetService';

export const loadAssets = createAsyncThunk('businessAssets/load', async () => fetchAssets());
export const createAssetRecord = createAsyncThunk('businessAssets/create', async (payload) => addAsset(payload));
export const updateAssetRecord = createAsyncThunk('businessAssets/update', async ({ id, changes }) => updateAsset(id, changes));
export const deleteAssetRecord = createAsyncThunk('businessAssets/delete', async (id) => deleteAsset(id));

const assetsSlice = createSlice({
  name: 'businessAssets',
  initialState: { status: 'idle', mutationStatus: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAssets.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(loadAssets.fulfilled, (state, action) => { state.status = 'succeeded'; state.items = action.payload; })
      .addCase(loadAssets.rejected, (state, action) => { state.status = 'failed'; state.error = action.error.message; })
      .addMatcher(
        (action) => [createAssetRecord.pending.type, updateAssetRecord.pending.type, deleteAssetRecord.pending.type].includes(action.type),
        (state) => { state.mutationStatus = 'loading'; state.error = null; }
      )
      .addCase(createAssetRecord.fulfilled, (state, action) => { state.mutationStatus = 'succeeded'; state.items.unshift(action.payload); })
      .addCase(updateAssetRecord.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        const index = state.items.findIndex((item) => item.id === action.payload.id);
        if (index >= 0) state.items[index] = action.payload;
      })
      .addCase(deleteAssetRecord.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        state.items = state.items.filter((item) => item.id !== action.payload);
      })
      .addMatcher(
        (action) => [createAssetRecord.rejected.type, updateAssetRecord.rejected.type, deleteAssetRecord.rejected.type].includes(action.type),
        (state, action) => { state.mutationStatus = 'failed'; state.error = action.error.message; }
      );
  }
});

export default assetsSlice.reducer;
